module.exports = __webpack_public_path__ + "static/media/cafe24-step1.29a8d6e1.png";